var _        = require('underscore');
var $        = require('jquery');

var Core            = require('../core/core.js');
var SidebarVersions = require('./sidebar__versions.js');

/**
 * Creates a sidebar
 *
 * @class
 */

class Sidebar extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'position': 'right',
                'width': '250px',
                'theme': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar js-editor__sidebar"></div>
        `;

        super.render();

        //set position
        this.$el.css('float', options.fields['position']);

        //set width
        this.$el.css('width', options.fields['width']);

        //set theme
        if(options.fields['theme'] === 'dark') {
            this.$el.addClass('editor--dark');
        }
    }

    /**
     * Adds versions
     */
    addVersions(){
        return new SidebarVersions({
            target: this.$el
        });
    }

    hide(){
        this.$el.addClass('hide');
    }
    /*
     * Shows the sidebar after it has been hidden
     */
    show(){
        this.$el.removeClass('hide');
    }
}
module.exports = Sidebar;